import { NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class DeleteProcessingFileCommand  {
    public processingFileId: number = 0;
}